import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BlogInfo',
})(({ brandColors, spacing, breakpoints }) => ({
  blogInfo: {
    color: brandColors.tintsNeutral20,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
    marginTop: spacing(1),
    marginBottom: spacing(1),

    [breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: spacing(4),
    },

    '& > *': {
      flex: 1,
    },
  },
  rowWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(-1),
  },
  socialIcons: {
    display: 'flex',
    gap: spacing(2),
    color: `${brandColors.tintsNeutral20}`,

    '& > a:hover': {
      color: `${brandColors.mediumBlue}`,
    },
  },
  publishingInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
  },
  tableOfContentsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default useStyles;
